import { render, staticRenderFns } from "./DepartmentName.vue?vue&type=template&id=a9d717f6&scoped=true&"
import script from "./DepartmentName.vue?vue&type=script&lang=js&"
export * from "./DepartmentName.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentName.vue?vue&type=style&index=0&id=a9d717f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d717f6",
  null
  
)

export default component.exports